import Head from "next/head";
import { getSimplePageLayout } from "src/components/elements/layout";
import { MypageDeleteAccountBody } from "src/components/features/mypage/help/deleteAccount";

export default function DeleteAccount() {
  return (
    <>
      <Head>
        <title>menu -アカウント削除ページ</title>
        <meta
          name="description"
          content="デリバリーサービス「menu」のアカウント削除ページです。"
        />
      </Head>
      <MypageDeleteAccountBody />
    </>
  );
}

DeleteAccount.getLayout = getSimplePageLayout;
